function viewPortConversion() {
    const vh = 85
    const vw = 80
  
    const viewPortWidth = window.innerWidth
    const viewPortHeight = window.innerHeight
  
    const height = (vh*viewPortHeight)/100
    const width = (vw*viewPortWidth)/100

    return {height, width}
}

export default viewPortConversion